import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currUser: {},
    coms: null,
    dict: {}
  },
  mutations: {
    'SET-CURRUSER'(state, user) {
      state.currUser = Object.assign({}, state.currUser, user)
    },
    'SET-BXCOMS'(state, coms) {
      state.coms = coms
    },
    SET_DICT: (state, { type, list }) => {
      const obj = {}
      obj['dict_' + type] = list
      state.dict = Object.assign({}, state.dict, obj)
    }
  },
  actions: {
    setUserInfo({ commit }, user) {
      commit('SET-CURRUSER', user)
    },
    setBxComs({ commit }, coms) {
      commit('SET-BXCOMS', coms)
    },
    setDict({ commit }, { type, list }) {
      commit('SET_DICT', { type, list })
    }
  }
})
